import StoredLayout from '../../layouts/StoredLayout'
import Lists from './Lists'
export default StoredLayout(Lists)
